var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [
      _vm._v(_vm._s(_vm.$t("page.userTop"))),
    ]),
    _vm._v(" "),
    _vm.isUserAuth
      ? _c("p", [
          _vm._v(
            _vm._s(_vm.$t("msg.signInGreeting", { name: _vm.userDispName }))
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }